
import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../system/mixins";
import { AuthenticationMixin } from "../../mixins";
import { BrowserUtility, BrowserKinds } from "../../../../utilities";

@Component
export default class AuthenticationDialogMixin extends Mixins(AuthenticationMixin, DialogMixin) {
  data(): any {
    return {
      result: false,
      userId: "",
    };
  }
  result: boolean;
  userId: string;

  get disabledAuthenticate(): boolean {
    return (this.isAuthenticating || this.userId === "" || this.password === "");
  }

  get shouldUseImelessTextarea(): boolean {
    return (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer)
        && !BrowserUtility.isMobile()
        && !BrowserUtility.isTouchSupported();
  }

  close(): void {
    this.isVisible = false;
  }
}
